import React from 'react';
import { months, isURL, isImage, getEventDate } from "../helper";

const Events = (EventData : any) => {

    const EventsList = Object.values(EventData).map((item: any, index) => {

        const eventDate = new Date(getEventDate(item).date);

        const getEventTime = () => {
            const hours = eventDate.getHours().toString() == '0' ? '00' : eventDate.getHours();
            const minutes = eventDate.getMinutes().toString() == '0' ? '00' : eventDate.getMinutes();
            return `${hours}:${minutes}`;
        }

        return (
            <div key={index} className="row event">
                <div className="col-4 col-md-3">
                    <div className="event-date text-wrap h-100">
                        <div className="display-5 fw-semibold">{months[eventDate.getMonth()]}</div>
                        <div className="display-1 fw-semibold">{eventDate.getDate()}</div>
                        { getEventDate(item).time ?
                           <div className="display-6">
                               {getEventTime()}
                           </div> : ""}
                        <span></span>
                    </div>
                </div>
                <div className={ isImage(item) ? `col-8 col-md-5` : `col-8 col-md-9`}>
                    <div className="event-details text-wrap p-0 py-2 p-lg-4 overflow-hidden">
                        <h2 className="fw-normal">{item.summary}</h2>
                        <p className="small" dangerouslySetInnerHTML={isURL(item.description)}></p>
                        <p className="small" dangerouslySetInnerHTML={isURL(item.location)}></p>
                        <p>
                            <a href={item.htmlLink} target="_blank" className="text-secondary fw-semibold text-decoration-none">Open in Google Calendar</a>
                        </p>
                    </div>
                </div>
                { isImage(item) ?
                    <div className="col-4 d-none d-md-block">
                        <div className="event-image image-wrap">
                            <img decoding="async" src={isImage(item)}/>
                        </div>
                    </div>
                : "" }
            </div>
        )
    })

    return (
        <>{EventsList}</>
    )
}

export default Events;
